import { CorporateTravel } from "redmond";

/**
 * `corporateTravel.policyCompliance.isInPolicy` is computed once by the
 * backend at shop time. If the traveler adds a fintech ancillary (CFAR,
 * disruption protection) or a seat during checkout, the total can cross the
 * policy limit without that flag ever updating — silently letting an
 * out-of-policy trip through checkout with no justification prompt. This
 * recomputes an effective compliance result against the ancillary-inclusive
 * checkout total so the book workflow can react to it.
 *
 * Never flips an already-out-of-policy fare back to in-policy — the
 * backend's original determination can rely on factors (fare class, airline,
 * etc.) this recompute doesn't have access to.
 */
export const getEffectiveCorporateTravel = ({
  corporateTravel,
  totalWithAncillaries,
  limit,
}: {
  corporateTravel: CorporateTravel | undefined;
  totalWithAncillaries: number | undefined;
  limit: number | undefined;
}): CorporateTravel | undefined => {
  if (corporateTravel == null || limit == null || totalWithAncillaries == null) {
    return corporateTravel;
  }

  const { isInPolicy, reasons } = corporateTravel.policyCompliance;
  if (!isInPolicy || totalWithAncillaries <= limit) {
    return corporateTravel;
  }

  return {
    policyCompliance: {
      isInPolicy: false,
      reasons: [...reasons, "TOO_EXPENSIVE"],
    },
  };
};
